<template>
    <b-modal id="modal-log-stok" :title="fullname" size="xl"
        centered no-close-on-backdrop hide-footer
    >
        <div class="search-wrapper d-flex align-items-center justify-content-between">
            <b-form-group
                label="Filter"
                label-for="filterInput"
                class="form-inline form-group-wrapper mb-3"
            >
                <div class="d-flex search-input-wrapper">
                    <b-form-select class="ml-2 mr-2" v-model="filter.tipe" :options="optTipe">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled>Tipe</b-form-select-option>
                            <b-form-select-option value=-1>Semua</b-form-select-option>
                        </template>
                    </b-form-select>
                    <b-form-input class="mr-2" v-model="filter.start" type="date" />
                    <b-form-group label="s.d." label-cols>
                        <b-form-input class="mr-2" v-model="filter.end" type="date" />
                    </b-form-group>
                </div>
            </b-form-group>
        </div>
        <div class="search-wrapper d-flex align-items-center justify-content-between">
            <b-form-group
                label="Sortir"
                label-for="sortir"
                class="form-inline form-group-wrapper mb-3"
            >
                <div class="d-flex search-input-wrapper">
                    <b-form-select class="ml-2 mr-2" v-model="filter.sort" :options="optSort">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled>Sortir...</b-form-select-option>
                        </template>
                    </b-form-select>
                    <b-button variant="primary" @click="getItems">
                        <i class="fa fa-search" />
                    </b-button>
                </div>
            </b-form-group>
        </div>
        <b-table bordered hover show-empty
            :busy="isBusy"
            :items="items"
            :fields="fields"
            responsive class="mb-3"
        >
            <template v-slot:empty>
                Tidak ada inventori.
            </template>
            <template v-slot:cell(created)="row">
                {{ $helper.parseDate(row.item.createdAt) }}, {{ $helper.parseHourMinute(row.item.createdAt) }}
                <div class="small text-muted">{{ row.item.createdBy }}</div>
            </template>
            <template v-slot:cell(tipe)="row">
                <b-badge :variant="parseStatusBadge(row.item.tipe.id)">{{ row.item.tipe.name }}</b-badge>
            </template>
            <template v-slot:cell(foto)="row">
                <div v-if="row.item.foto == null">No Photo</div>
                <a v-else :href="$BASE_FILE_PATH + row.item.foto" target="_blank">
                    <img :src="$BASE_FILE_PATH + row.item.foto" height="40" />
                </a>
            </template>
            <template v-slot:cell(sku)="row">
                {{ row.item.model }}
                <div class="small text-muted">{{ row.item.kategori }}</div>
                <div class="small">{{ row.item.sku }}</div>
            </template>
        </b-table>
        <div class="pagination-wrapper d-flex align-items-center justify-content-between">
            <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" />
            <b-pagination class="mb-0"
                v-model="currentPage"
                :totalRows="totalRows"
                :per-page="perPage"
                @change="onPageChange"
            />
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'dashboard-modal-log',
    props: {
        item: { type: Object, required: true }
    },
    data() {
        return {

            fullname: "",

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,

            filter: {
                tipe: -1,
                start: "",
                end: "",
                sort: 1
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "created", label: "Tanggal / Eksekutor" },
                { key: "sku", label: "Produk" },
                { key: "ukuran", label: "Ukuran" },
                { key: "warna", label: "Warna" },
                { key: "tipe", label: "Tipe" },
                { key: "jumlah", label: "Jumlah" },
                { key: "stokSetelah", label: "Stok Setelah" },
                { key: "keterangan", label: "Keterangan" }
            ],

            items: [],
            activeItem: {},

            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            totalPages: 0,

            optKategori: [],
            optSort: [
                { text: "Dari Terbaru", value: 1 },
                { text: "Dari Terlama", value: 2 }
            ],
            optTipe: [
                { text: "Tambah", value: 1 },
                { text: "Kurang", value: 2 },
                { text: "Penjualan", value: 3 },
            ]

        }
    },
    methods: {

        getItems(page = 1) {

            let query = ""

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage - 1, this.perPage)
            param += "&warnaId=" + this.item.id
            param += "&sortAsc=" + (this.filter.sort == 2 ? "true" : "false")

            if(!this.$helper.isBlank(this.filter.start)) {
                param += "&filterStart=" + this.filter.start
            }

            if(!this.$helper.isBlank(this.filter.end)) {
                param += "&filterEnd=" + this.filter.end
            }

            if(this.filter.tipe != -1) {
                param += "&filterTipe=" + this.filter.tipe
            }

            // Execute
            return this.$axios.get("log-stok/" + param).then(res => {

                this.items = res.data.data
                this.totalRows = res.data.total

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems()
        },

        onPageChange(newPage) {
            this.getItems(newPage)
        },

        parseStatusBadge(id) {

            switch(id) {
                case 1: return "success"
                case 2: return "danger"
                case 3: return "primary"
                default: return "light"
            }

        }

    },
    watch: {

        item: function(newValue) {

            if(newValue != {}) {
                this.fullname = `${this.item.model} (${this.item.ukuran}) - ${this.item.warna}`
                this.getItems(1)
            }

        }

    }
}
</script>
